/**
 * Platform definitions for connected accounts.
 *
 * Each platform has an id, display name, simple icon representation,
 * and brand color for visual identification.
 */

export const PLATFORMS = [
  { id: 'youtube', name: 'YouTube', icon: '▶', color: '#FF0000', baseUrl: 'https://youtube.com/@' },
  { id: 'twitch', name: 'Twitch', icon: 'T', color: '#9146FF', baseUrl: 'https://twitch.tv/' },
  { id: 'instagram', name: 'Instagram', icon: 'IG', color: '#E1306C', baseUrl: 'https://instagram.com/' },
  { id: 'tiktok', name: 'TikTok', icon: '♪', color: '#00F2EA', baseUrl: 'https://tiktok.com/@' },
  { id: 'x', name: 'X', icon: '𝕏', color: '#FFFFFF', baseUrl: 'https://x.com/' },
  { id: 'facebook', name: 'Facebook', icon: 'f', color: '#1877F2', baseUrl: 'https://facebook.com/' },
  { id: 'kick', name: 'Kick', icon: 'K', color: '#53FC18', baseUrl: 'https://kick.com/' },
];

/**
 * Get platform by ID.
 * @param {string} id - Platform identifier
 * @returns {Object|undefined} Platform object or undefined if not found
 */
export const getPlatformById = (id) => PLATFORMS.find((p) => p.id === id);

export const getPlatformUrl = (platformId, username) => {
  const platform = getPlatformById(platformId);
  if (!platform?.baseUrl || !username) return null;
  if (platformId === 'youtube') {
    const normalizedUsername = String(username).trim();
    if (normalizedUsername.startsWith('channel/')) {
      return `https://youtube.com/${normalizedUsername}`;
    }
  }
  return `${platform.baseUrl}${username}`;
};
